import api from './axiosConfig';
import { PORTFOLIO_ENDPOINT } from './apiEndpoints';
import { getItem } from "../utils/localStorageUtil";
import { logError } from './errorLogService';

const isZho = getItem('lang') == 'zho'

const mockData =
    [
        {
            id: 2001,
            image_src: "/assets/images/portfolio/family-2001.jpg",
            image_alt: "Reinbow herbicides",
            description: isZho ? '除草剂' : 'Herbicides',
            order: 1
        },
        {
            id: 2002,
            image_src: "/assets/images/portfolio/family-2002.jpg",
            image_alt: isZho ? '杀菌剂' : "Reinbow Fungicides",
            description: isZho ? '杀菌剂' : 'Fungicides',
            order: 2
        },
        {
            id: 2003,
            image_src: "/assets/images/portfolio/family-2003.jpg",
            image_alt: isZho ? '杀虫剂' : "Reinbow Insecticides",
            description: isZho ? '杀虫剂' : 'Insecticides',
            order: 3
        },
        {
            id: 2005,
            image_src: "/assets/images/portfolio/family-2005.jpg",
            image_alt: isZho ? '种子处理' : "Reinbow Seed Treatment",
            description: isZho ? '种子处理' : 'Seed Treatment',
            order: 4
        },
        {
            id: 2004,
            image_src: "/assets/images/portfolio/family-2004.jpg",
            image_alt: isZho ? '植物生长调节剂' : "Reinbow Plant Growth Regulators",
            description: isZho ? '植物生长调节剂' : 'Plant Growth Regulators',
            order: 5
        },
        {
            id: 2008,
            image_src: "/assets/images/portfolio/family-2008.jpg",
            image_alt: isZho ? '生物肥料' : "Reinbow Bio-Fertilizers",
            description: isZho ? '生物肥料' : 'Bio-Fertilizers',
            order: 6
        },
        {
            id: 2007,
            image_src: "/assets/images/portfolio/family-2007.jpg",
            image_alt: isZho ? '生物农药' : "Reinbow Bio-Pesticides",
            description: isZho ? '生物农药' : 'Bio-Pesticides',
            order: 7
        },
        {
            id: 2006,
            image_src: "/assets/images/portfolio/family-2006.jpg",
            image_alt: isZho ? '生物刺激素' : "Reinbow Biostimulants",
            description: isZho ? '生物刺激素' : 'Biostimulants',
            order: 8
        },
    ];

export const fetchPortfolio = async (retryCount = 2) => {

    try {
        const response = await api.get(PORTFOLIO_ENDPOINT(), {
            timeout: 30000, // 30 seconds timeout
        });

        const data = response.data.map((item) => ({
            ...item,
            image_alt: `Rainbow ${item.description}`,
        }));
        return data;
    } catch (error) {
        const isTimeout = error.code === 'ECONNABORTED' || error.message?.includes('timeout');
        const isNetworkError = !error.response && error.request;
        
        // Retry logic for timeouts and network errors
        if ((isTimeout || isNetworkError) && retryCount > 0) {
            console.warn(`Portfolio data fetch ${isTimeout ? 'timeout' : 'network error'}, retrying... (${retryCount} attempts left)`);
            await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 1 second before retry
            return fetchPortfolio(retryCount - 1);
        }

        console.error("Error fetching fetchPortfolio data", error);

        await logError('portfolio_data_fetch', error, {
            endpoint: PORTFOLIO_ENDPOINT(),
            response_status: error.response?.status,
            response_data: error.response?.data,
        });

        return mockData;
    }
};
